export class Vestiging {
  naam!:string;
  straat:string | undefined;
  huisnummer: number | undefined;
  toevoeging: string | undefined;
  gemeente: string | undefined;
  maps_link: string | undefined;
}
